export default "6db585ed3f952de5.jpg"